package com.eladfinish.bible.contest.ui.components.sliders

import androidx.compose.material3.Slider
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.ui.platform.LocalLayoutDirection
import androidx.compose.ui.unit.LayoutDirection
import kotlin.math.roundToInt

@Composable
fun DottedDiscreteSlider(
    progress: Float, // 0..14
    onProgressChange: (Float) -> Unit,
    maxProgress: Int = 14,
) {
    // Force LTR so the active (colored) part stays on the LEFT even in Hebrew/RTL UI.
    CompositionLocalProvider(LocalLayoutDirection provides LayoutDirection.Ltr) {
        Slider(
            value = progress,
            onValueChange = { raw ->
                // Snap to discrete integer steps (like SeekBar progress)
                onProgressChange(raw.roundToInt().toFloat().coerceIn(0f, maxProgress.toFloat()))
            },
            valueRange = 0f..maxProgress.toFloat(),
            // steps = number of *intermediate* values (excluding endpoints)
            steps = (maxProgress - 1).coerceAtLeast(0), // for 0..14 -> 13
        )
    }
}
